import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslateService } from './services/translate.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { id } from 'date-fns/locale';
import { ModalTerminalComponent } from './app/shared/components/modal-terminal/modal-terminal.component';
import { DashCloseIconComponent } from './app/shared/components/dash-close-icon/dash-close-icon.component';
import { Store } from '@ngrx/store';
import { accountSelector } from './app/store/account/account.selectors';

@Component({
  selector: 'ze-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  protected readonly dialogService = inject(DialogService);
  private readonly store = inject(Store)
  license = this.store.selectSignal(accountSelector.licenseStatus)
  modalRef?: DynamicDialogRef | null;
  title = 'ze';
  ngOnInit() {
    this.translateService.setPrimeNGTranslations();
  }

  openTerminal() {
    if (this.license().status !== 'ACTIVE') {
      return
    }
    this.modalRef = this.dialogService.open(ModalTerminalComponent, {
      header: 'Terminal',
      width: '80vw',
      data: {
        context: 'agent',
        contextId: id,
        message: 'Associare nuovo vault sovrascrivendo quello associato??',
        title: '',
      },
      keepInViewport: true,
      closable: true,
      modal: true,
      dismissableMask: true,
      focusOnShow: false,
      maximizable: true,
      focusTrap: true,
      breakpoints: { '640px': '90vw' },
    });
    this.modalRef!.onClose.subscribe((result) => {
      if (result?.success === true) {
      }
    });
  }
}
